import { default as BSButton } from 'bootstrap/js/src/button'

class Button extends BSButton {}

export default Button
